import { testimonials } from "@/mocks/guage";

const toneMap: Record<string, string> = {
  primary: "bg-primary-500 text-background-50",
  accent: "bg-accent-500 text-background-50",
  secondary: "bg-secondary-500 text-background-50",
};

export default function VoiceSection() {
  return (
    <section id="voice" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-5">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-primary-700 text-xs md:text-sm font-medium">
              <span className="w-6 h-px bg-primary-500"></span>
              瓜友怎么说
            </span>
            <h2 className="mt-4 font-heading text-3xl md:text-5xl text-foreground-950">瓜友口碑</h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              来自评论区和订阅邮箱里的真实反馈。有夸有怼，我们都收着。
            </p>
          </div>
          <div className="flex items-center gap-3">
            <span className="font-heading text-4xl md:text-5xl text-primary-600">4.9</span>
            <div className="flex flex-col">
              <span className="flex text-accent-500">
                {[0, 1, 2, 3, 4].map((i) => (
                  <i key={i} className="ri-star-fill text-lg"></i>
                ))}
              </span>
              <span className="text-xs text-foreground-500 mt-1">来自 12,480 位瓜友评分</span>
            </div>
          </div>
        </div>

        <div className="mt-9 md:mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {testimonials.map((item) => (
            <figure
              key={item.name}
              className="flex flex-col p-5 md:p-6 rounded-lg bg-background-100 border border-background-200"
            >
              <span className="flex text-accent-500">
                {[0, 1, 2, 3, 4].map((i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </span>
              <blockquote className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
                {item.text}
              </blockquote>
              <figcaption className="mt-auto pt-5 flex items-center gap-3">
                <span
                  className={`w-10 h-10 flex items-center justify-center rounded-full font-heading text-lg shrink-0 ${
                    toneMap[item.tone] ?? toneMap.primary
                  }`}
                >
                  {item.initial}
                </span>
                <span className="flex flex-col leading-tight">
                  <span className="text-sm font-medium text-foreground-950">{item.name}</span>
                  <span className="text-xs text-foreground-500 mt-0.5">{item.tag}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}